import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, imageAddress } from '../../utils/useful'

class VideoWidget extends React.Component {
    state = {
        show: true
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data?.source != this.props.data?.source || this.props.params != prevProps.params) {
            this.init()
        }
    }

    init() {


        let data = this.props.data?.source
        if (data) {
            data = this.textVariableReplacer(this.props.fullData, data, this.props.headers, 'Current Record')

            // console.log(this.props.params)
            if (Array.isArray(this.props.params)) {
                for (let i = 0; i < this.props.params.length; i++) {
                    const param = this.props.params[i];

                    // console.log(param)
                    data = this.textVariableReplacer(param?.info, data, param.fields, param.label)
                    // console.log(data)
                }
            }

            // console.log(data)

            this.setState({ data, show: false }, () => {
                this.setState({ show: true })
            })
        }
    }




    textVariableReplacer = (data, content, fields, preLabel) => {

        console.log(content)
        console.log(fields)

        if (content && typeof content == 'string') {

            let output = content

            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)

            if (matches) {
                for (let index = 0; index < matches.length; index++) {
                    const match = matches[index];


                    let key = match.replace(/{/g, '').replace(/}/g, '')


                    if (fields) {
                        for (let j = 0; j < fields.length; j++) {
                            const header = fields[j];

                            let label = checkTranslation(header.information?.label)
                            if (preLabel) {
                                label = preLabel + ' - ' + label
                            }

                            // console.log(label)
                            // console.log(key)


                            if (key == label || key == header.key) {


                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }


                                // let nreg = new RegExp(match, 'g')
                                // output = output.replace(nreg, value)
                                output = value

                            }


                        }
                    }
                }
            }

            return output

        }

    }

    // init() {
    //     let data = this.props.data?.source
    //     let output = data
    //     if (typeof data == 'string' && /\{\{(.*?)\}\}/.test(data)) {
    //         let reg = new RegExp('\{\{(.*?)\}\}', 'g')
    //         // console.log("TEST!!")
    //         let matches = data.match(reg)

    //         if (matches && matches.length > 0) {
    //             for (let index = 0; index < matches.length; index++) {
    //                 const match = matches[index];

    //                 // console.log("here!!!")
    //                 let key = match.replace(/{/g, '').replace(/}/g, '')

    //                 // console.log(matches)
    //                 // console.log(key)

    //                 if (this.props.headers) {
    //                     for (let j = 0; j < this.props.headers.length; j++) {
    //                         const header = this.props.headers[j];

    //                         // console.log(header?.key)
    //                         // console.log(header?.type)

    //                         if (((key == header?.information?.label || key == header.key || ('values.' + key) == (header.key))) && header.type == 'ImageInput') {
    //                             let value = getObject(this.props.fullData, header.key)
    //                             // console.log(value)
    //                             // let nreg = new RegExp(match, 'g')
    //                             output = value
    //                         }
    //                     }
    //                 }
    //             }
    //             if (/\{\{(.*?)\}\}/.test(output)) {
    //                 output = null
    //             }
    //         }
    //     } else if (data == '**custom') {
    //         output = this.props.header?.information?.address
    //     }



    //     this.setState({ data: output })

    // }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    renderImage(image, index, margin, local) {
        // let styleInfo = this.props.styleInfo

        // console.log(image)


        if (typeof image == 'string') {
            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = image.match(reg)

            if (matches) {

                image = null

            }
        }


        let mimageAddress = imageAddress(image, 'videoCover', null, 'cover')

        let information = this.props.header?.information
        let styleInfo = information?.style



        // if (local) {
        //   mimageAddress = imageAddress(null)
        // }

        // console.log(image)
        // console.log(mimageAddress)

        let aspectRatio
        if (information?.antecedent || information?.consequent) {
            aspectRatio = (Number(information.antecedent) ?? 1) + "/" + (Number(information.consequent) ?? 1)
        }

        // console.log(aspectRatio)
        let objectFit = information?.objectFit ?? 'cover'

        return (
            <img key={index} src={mimageAddress} style={{ aspectRatio, width: styleInfo?.width ? (styleInfo?.width + (styleInfo?.widthUnit ?? '%')) : '100%', borderRadius: styleInfo?.borderRadius ?? 10, objectFit }} />
        )

    }



    renderVideo(image, index, margin, local) {
        // let styleInfo = this.props.styleInfo

        // console.log(image)
        let mimageAddress = imageAddress(image, 'videoCover', null, 'cover')
        let mimageVideo = imageAddress(image, 'video', null)

        let information = this.props.header?.information
        let styleInfo = information?.style
        // if (local) {
        //   mimageAddress = imageAddress(null)
        // }

        // console.log(image)
        // console.log(mimageAddress)

        let aspectRatio
        if (information?.antecedent || information?.consequent) {
            aspectRatio = (Number(information.antecedent) ?? 1) + "/" + (Number(information.consequent) ?? 1)
        }

        // console.log(aspectRatio)
        let objectFit = information?.objectFit ?? 'cover'

        return (
            <video id="myImage" width={'100%'} style={{ width: '100%' }} src={this.state.video} key={this.state.video} controls poster={mimageAddress}>
                <source id="mySource" src={mimageVideo} type="video/mp4"></source>
            </video>
        )

    }


    render() {

        let information = this.props.header?.information
        let styleInfo = this.props.header?.information?.style
        let justifyContent = styleInfo?.align
        // let data = this.props.data?.source

        // console.log(this.props.header?.information)
        return (

            <div className="text-center d-flex  w-100" style={{ overflow: 'auto', justifyContent: justifyContent ?? 'center' }}>

                {this.state.show && (
                    <>
                        {information.showCover && (
                            <div className='w-100'>
                                {!Array.isArray(this.state.data) && this.state.data && (
                                    this.renderImage(this.state.data)
                                )}

                                {!this.state.data && (
                                    this.renderImage(null, null, null, true)
                                )}
                            </div>

                        )}


                        {!information.showCover && (
                            <div className='w-100'>
                                {!Array.isArray(this.state.data) && this.state.data && (
                                    this.renderVideo(this.state.data)
                                )}

                                {!this.state.data && (
                                    this.renderVideo(null, null, null, true)
                                )}
                            </div>

                        )}
                    </>
                )}
            </div>

        )
    }
}

export default VideoWidget;